import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const instrumentationKey = process.env.REACT_APP_INSIGHTS_APP_KEY?.trim();

// Application Insights throws during initialization when no key is configured.
// Keep local development and deployments without telemetry configuration usable.
const appInsights = instrumentationKey
  ? new ApplicationInsights({
      config: {
        instrumentationKey,
        extensions: [reactPlugin],
      },
    })
  : {
      trackException: () => {},
    };

if (instrumentationKey) {
  appInsights.loadAppInsights();
}

export { reactPlugin, appInsights };